<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4.92969" y="17.6567" width="18" height="2" rx="1" transform="rotate(-45 4.92969 17.6567)" fill="black" />
    <rect x="6.34375" y="4.92871" width="18" height="2" rx="1" transform="rotate(45 6.34375 4.92871)" fill="black" />
  </svg>
</template>

<script setup lang="ts"></script>
